// Obligation-light copy for admin-bucket dock sections (§5.3 / RA-3 parking).

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import type { PendingMemberApprovalCounts } from "@/lib/admin/pendingMemberApprovalCount";
import { totalPendingMemberApprovals } from "@/lib/admin/pendingMemberApprovalCount";

export function formatPendingApprovalsBodyLine(
  counts: PendingMemberApprovalCounts,
  currentMode: PrimaryMode | null,
): string {
  const total = totalPendingMemberApprovals(counts);
  const waiting =
    total === 1 ? "1 person is" : `${total} people are`;
  if (currentMode === "admin") {
    return `${waiting} waiting in Admin → Users for access review.`;
  }
  return `${waiting} waiting for org access review. Open Admin when you're ready.`;
}

export function formatOrgUnsentRollupBodyLine(
  count: number,
  currentMode: PrimaryMode | null,
): string {
  const noun = count === 1 ? "lead" : "leads";
  if (currentMode === "dashboard") {
    return `Your team has ${count} unsent ${noun} on record — view-only snapshot.`;
  }
  return `Team-wide: ${count} unsent ${noun} across reps (read-only).`;
}
